// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'babel-polyfill'
import Vuex from 'vuex'
import store from './vuex/store'
import '../theme/index.css'
// import './utils/rem'
// import store from './store/index.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import envConfig from '@/constants/env'

Vue.use(Vuex)
Vue.use(VueAwesomeSwiper /* { default global options } */)

const env = process.env.API_ENV || 'dev'
const {
  baseURL,
  openUrl,
  adminUrl,
  liantongUrl
} = envConfig[env]

axios.defaults.baseURL = baseURL // 接口地址
Vue.prototype.openUrl = openUrl // 开放平台跳转地址
Vue.prototype.adminUrl = adminUrl // 应用管理登录地址
Vue.prototype.liantongUrl = liantongUrl // 联通管理后台地址

window.localStorage.setItem('clientId', '56B491AA6A5F2AA8E1495D8F5AC3E126')
axios.defaults.withCredentials = true
axios.defaults.timeout = 5000
Vue.config.productionTip = false
var alert = require('element-ui').MessageBox.alert
var message = require('element-ui').Message
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  const fromQuery = from.query
  const toQuery = to.query
  if (to.path !== '/application/list/-1' && to.path !== '/application/solutiondetail') {
    window.sessionStorage.removeItem('activeName')
    next()
  }

  if (fromQuery.code && fromQuery.code !== toQuery.code) {
    toQuery.code = fromQuery.code
    const nextPath = {
      path: to.path,
      query: toQuery
    }
    next(nextPath)
    return
  }
  next()
})

// function getToken () {
//   var accessToken = window.localStorage.getItem('access-token')
//   if (accessToken) {
//     // alert('accessToken----' + accessToken)
//     return Promise.resolve(accessToken)
//   } else {
//     return new Promise((resolve, reject) => {
//       // alert('没有 access-token')
//     })
//   }
// }
axios.interceptors.request.use(config => {
  var paramsTime = new Date().getTime()
  if (config.url.indexOf('&') !== -1 || config.url.indexOf('?') !== -1) {
    config.url = config.url + '&t=' + paramsTime
  } else {
    config.url = config.url + '?t=' + paramsTime
  }
  if (config.url.indexOf('/shop/partner') === -1 && config.url.indexOf('/token/update/token/refreshtoken') === -1 &&
    config.url.indexOf('/shop/apply/info') === -1 && config.url.indexOf('/operator/login') === -1 && config.url.indexOf(
      '/shop/tag/list') === -1 && config.url.indexOf('/shop/tag') === -1) {
    var accessToken = window.localStorage.getItem('access-token')
    if (accessToken) {
      config.headers['access-token'] = accessToken
    }
    return config
  } else {
    return config
  }
}, err => {
  // alert('err-request', err)
  return Promise.reject(err)
})

// var currentGetNewTokenPromise
// async function refreshAccessToken () {
//   if (!currentGetNewTokenPromise) {
//     currentGetNewTokenPromise = axios.put('/token/update/token/refreshtoken/' + window.localStorage.getItem(
//       'refreshToken'))
//   }
//   let newTokenResult = await currentGetNewTokenPromise
//   let newAccessToken = newTokenResult.data.code === '0' ? newTokenResult.data.data : ''
//   if (newAccessToken) {
//     await window.localStorage.setItem('access-token', newAccessToken)
//   } else {
//     refreshApp()
//   }
//   currentGetNewTokenPromise = undefined
//   return newAccessToken
// }

async function responseInterceptor (response) {
  console.log('response', response)
  if (response.data.code === '0') {
    return response && response.data
  } else if (response.data.code === 'TOWN_0041') {
    // refresh token
    // await refreshAccessToken()
    // send request again
    // return axios.request(response.config)
    alert('登录失效，请重新登录', '温馨提示', {
      confirmButtonText: '确定',
      callback: action => {
        router.push('/')
        window.localStorage.clear()
        window.location.reload()
      }
    })
  } else if (response.data.code === 'TOWN_0037') {
    // refreshApp()
    if (window.location.href === 'https://greenshop-dev.gtdreamlife.com/appstore#/' || window.location.href ===
      'https://greenshop-uat.gtdreamlife.com/appstore#/') {
      window.localStorage.removeItem('access-token')
      // window.location.reload()
    } else {
      alert('登录失效，请重新登录', '温馨提示', {
        confirmButtonText: '确定',
        callback: action => {
          router.push('/')
          window.localStorage.clear()
          window.location.reload()
        }
      })
    }
  } else {
    return response && response.data
    // 在添加其他的错误码判断
    // if (response.data.msg) {
    //   alert(response.data.msg, '温馨提示')
    // }
  }
}

// function refreshApp () {
//   window.localStorage.removeItem('access-token')
//   window.localStorage.removeItem('refreshToken')
//   window.location.href = window.location.href.replace(/#.*$/, '')
// }

// 设置拦截器
axios.interceptors.response.use(function (response) {
  return responseInterceptor(response)
}, function () {
  message.error('服务器出了点小差')
})
Vue.use(ElementUI)
Vue.prototype.$axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  alert,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js